export const OrderGroupStatus = {
	NEW: 1,
	DRIVER_ASSIGNED: 2,
	DELIVERED: 3,
	CANCELED: 4,
}

export const OrderGroupBadgeEnum = {
	new: 'red',
	driver_assigned: 'orange',
	delivered: 'green',
	canceled: 'gray',
}

export const OrderGroupStatusEnum = {
	new: '新規注文',
	driver_assigned: 'ドライバーアサイン済み',
	delivered: '配達完了',
	canceled: 'キャンセル済み',
}
